import React from "react";
import FormattedDate from "./FormattedDate";
import WeatherTemperature from "./WeatherTemperature";

export default function WeatherInfo(props) {
  return (
    <div className="WeatherInfo">
      <div className="row">
        <div className="col-4 mt-5">
          <h1>
            {props.data.city}, {props.data.country}
          </h1>
          <ul>
            <li>
              <FormattedDate date={props.data.date} />
            </li>
            <li className="text-capitalize">{props.data.description}</li>
          </ul>
        </div>
        <div className="col-4 mt-3 text-center">
          <img src={props.data.icon} alt={props.data.description}></img>
          <WeatherTemperature celsius={props.data.temperature} />
        </div>
        <div className="col-4 mt-4 text-end">
          <ul className="mt-5">
            <li>Feels like: {props.data.feelslike}°C</li>
            <li>Humidity: {props.data.humidity}%</li>
            <li>Wind: {props.data.wind} km/h</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
